// extracted by mini-css-extract-plugin
module.exports = {"muxVideo":"MuxVideo_muxVideo__tVnbO","hideControls":"MuxVideo_hideControls__eT_La"};